export const textShadow = '0 2px 5px rgba(0, 0, 0, 0.15)';
